import React, { Component } from 'react';
import { Form, Select, Spin } from 'antd';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  CategoriesSelect,
  CitiesSelectV2,
  CountriesSelectV2,
} from 'components';
import { ProjectsActions } from 'redux/actions';
import pickBy from 'loadsh/pickBy';
import identity from 'loadsh/identity';
import {
  Container,
  formLayout,
  formValidateMessages,
  HeadingOne,
  FormWrapper,
  PrimaryButtonV2,
  AddSelector,
  AddFormItemLabel,
  AddInput,
  PrimaryButton,
} from 'utils';
import { ArrowRightOutlined } from '@ant-design/icons';

const FormItem = Form.Item;
const { Option } = Select;

class CategorySelection extends Component {
  formRef = React.createRef();

  state = {
    cityValue: '',
    countryValue: '',
    andere: false,
    inputValue: '',
    selectedValue: '',
  };

  static propTypes = {
    updateDraft: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    isUniq: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    currentStep: PropTypes.number.isRequired,
    setCanMove: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    selectedStep: PropTypes.number.isRequired,
    setSubmitFromModal: PropTypes.func.isRequired,
  };

  onFinish = (values) => {
    const vals = {
      ...values,
      city: values.city,
      initiator_city: values.city,
      initiator_country: values.country,
      learned_about: this.state.andere
        ? this.state.inputValue
        : this.state.selectedValue,
    };
    const { updateDraft, projectId, currentStep, setCanMove } = this.props;
    if (projectId) {
      updateDraft(projectId, vals, currentStep);
      sessionStorage.removeItem('categoryType');
    } else {
      sessionStorage.setItem('categoryType', JSON.stringify(vals));
    }
    setCanMove(true);
    this.props.handleSteps(2);
  };

  handleChangeLink = (e) => {
    this.setState({ link: e.target.defaultValue });
  };

  handleCountryChange = (countryValue) => {
    this.setState({
      countryValue,
    });
  };

  handleCityChange = (cityValue) => {
    this.setState({
      cityValue,
    });
  };

  handleOnChange = (value) => {
    if (value === 'Andere') {
      this.setState({ andere: true, selectedValue: '', inputValue: '' });
    } else {
      this.setState({ andere: false, selectedValue: value, inputValue: '' });
    }
  };

  handleInputChange = (e) => {
    this.setState({ inputValue: e.target.value });
  };

  getContent = (content, name) => {
    this.formRef.current.setFieldsValue({ [name]: content });
  };

  onReturn = () => {
    this.props.handleSteps(1);
  };

  render() {
    const {
      project,
      loading,
      // isUniq,
      setCanMove,
      projectId,
    } = this.props;
    const { cityValue, countryValue, andere, inputValue, selectedValue } =
      this.state;

    const savedData = sessionStorage.getItem('categoryType');
    const parsedData = savedData ? JSON.parse(savedData) : {};

    return (
      <Container  style={{maxWidth: 480}}>
        <Spin spinning={projectId ? loading : false}>
          <HeadingOne>
            <h1>Grundlegendes</h1>
          </HeadingOne>
          <Form
            {...formLayout}
            ref={this.formRef}
            onChange={(e) => {
              return setCanMove(false);
            }}
            name="project-details"
            onFinish={this.onFinish}
            validateMessages={formValidateMessages}
            initialValues={
              projectId
                ? pickBy(project.categoryType, identity)
                : parsedData || ''
            }
          >
            <div>
              <FormWrapper>
                <>
                  <CategoriesSelect />
                  <FormItem
                    name="project_type"
                    label={<AddFormItemLabel>Projekttyp</AddFormItemLabel>}
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: 'Projekttyp ist erforderlich',
                      },
                    ]}
                  >
                    <AddSelector
                      placeholder="Typ auswählen"
                      style={{ width: '100%' }}
                    >
                      <Option key={'partial'}>Crowdfunding-Projekt</Option>
                      <Option key={'event'}>Event</Option>
                    </AddSelector>
                  </FormItem>

                  <CountriesSelectV2
                    handleCountryChange={this.handleCountryChange}
                    countryValue={countryValue}
                  />

                  <CitiesSelectV2
                    handleCityChange={this.handleCityChange}
                    cityValue={cityValue}
                    countryValue={countryValue}
                  />

                  <div>
                    <FormItem
                      name="learned_about"
                      label={
                        <AddFormItemLabel>
                          Woher kennst du commonsplace?
                        </AddFormItemLabel>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: 'erforderlich',
                        },
                      ]}
                    >
                      <AddSelector
                        placeholder="Antwort auswählen"
                        options={[
                          { value: 'Social Media', label: 'Social Media' },
                          {
                            value: 'Freunde und Familie',
                            label: 'Freunde und Familie',
                          },
                          { value: 'WhatsApp', label: 'WhatsApp' },
                          { value: 'Newsletter', label: 'Newsletter' },
                          { value: 'Google Suche', label: 'Google Suche' },
                          {
                            value:
                              'Printmedien wie Plakat oder Flyer von commonsplace',
                            label: 'Printmedien wie Plakat oder Flyer',
                          },
                          {
                            value: 'Facebook/Instagram Werbung',
                            label: 'Facebook/Instagram Werbung',
                          },
                          { value: 'Andere', label: 'Andere' },
                        ]}
                        style={{ width: '100%' }}
                        onChange={this.handleOnChange}
                        value={selectedValue}
                      />
                    </FormItem>
                    {andere && (
                      <FormItem
                        name="learn_about"
                        label={
                          <AddFormItemLabel>
                            Woher kennst du commonsplace?
                          </AddFormItemLabel>
                        }
                        required={false}
                        rules={[
                          {
                            required: true,
                            message: 'erforderlich',
                          },
                        ]}
                      >
                        <AddInput
                          value={inputValue}
                          onChange={this.handleInputChange}
                          placeholder="Details eingeben"
                        />
                      </FormItem>
                    )}
                  </div>
                </>
              </FormWrapper>
            </div>

            {/*
            <FormItem>
              <PrimaryButton
                type="primary"
              >
                <ArrowLeftOutlined /> Zurück
              </PrimaryButton>
            </FormItem>
            */}
            <FormItem style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <PrimaryButton
                type="primary"
                htmltype="submit"
                minWidth="120px"
                id="submit-button"
              >
                Weiter
                <ArrowRightOutlined />
              </PrimaryButton>
            </FormItem>
          </Form>
        </Spin>
      </Container>
    );
  }
}
const mapStateToProps = (state) => {
  const { currentStep, project, loading, errors, isUniq } = state.projects;
  return {
    currentStep,
    project,
    loading,
    errors,
    isUniq,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleSteps: (step) => dispatch(ProjectsActions.handleSteps(step)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CategorySelection);
